module.exports = __webpack_public_path__ + "static/store-icon-0d894e809df0646b45d8f8c0079f8dea.svg";